import {
    Controller
} from "stimulus"

export default class extends Controller {

    get formData()
    {
        return new FormData(this.element)
    }

    get searchParams()
    {
        return new URLSearchParams(this.formData)
    }

    get queryString()
    {
        return this.searchParams.toString()
    }

    submit()
    {
        this.element.submit()
    }
}
